export const nivo_theme = {
  fontFamily: "Plus Jakarta Sans, sans-serif",
  axis: {
    ticks: {
      text: {
        fontFamily: "Plus Jakarta Sans, sans-serif",
        fontWeight: "600",
        fill: "#718096",
      },
    },
    legend: {
      text: {
        fontFamily: "Plus Jakarta Sans, sans-serif",
        fontWeight: "bold",
        fontSize: 14,
      },
    },
  },
  legends: {
    text: {
      fontFamily: "Plus Jakarta Sans, sans-serif",
    },
  },
  labels: {
    text: {
      fontFamily: "Plus Jakarta Sans, sans-serif",
      fontSize: 18,
      fontWeight: "800",
    },
  },
  tooltip: {
    container: {
      fontFamily: "Plus Jakarta Sans, sans-serif",
      background: "#FFFFFF",
      border: "1px solid #85C22A",
      borderRadius: "8px",
      padding: "8px 12px",
      boxShadow: "none",
    },
  },
};
